// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WebinarInvitation__container-fe7512 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  margin: auto;
  box-sizing: border-box;
  position: relative;
  background-color: var(--addition-70);
  border: 1px solid var(--base-20);
  border-radius: 32px;
  width: 100%;
  max-width: 432px;
  height: 100%;
  max-height: 528px;
}

.WebinarInvitation__title-c07224 {
  text-align: center;
  font: var(--font-title-6);
  color: var(--base-110);
  margin-top: 24px;
}

.WebinarInvitation__subtitle-d101d0 {
  text-align: center;
  font: var(--font-body-4);
  color: var(--base-80);
  letter-spacing: var(--font-spacing-body-4);
}

.WebinarInvitation__description-c3c33c {
  text-align: center;
  font: var(--font-subtitle-4);
  color: var(--base-70);
  letter-spacing: var(-font-spacing-subtitle-4);
}

.WebinarInvitation__listen-only-b82e5e {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font: var(--font-subtitle-3);
}

.WebinarInvitation__mic-icon-aadedb {
  fill: var(--base-70);
}

.WebinarInvitation__start-call-b8994b {
  padding: 24px 0;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/RoomCallPreviewPopup/WebinarInvitation/WebinarInvitation.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,0CAAA;AACF;;AAEA;EACE,kBAAA;EACA,4BAAA;EACA,qBAAA;EACA,6CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,4BAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  margin: auto;\n  box-sizing: border-box;\n  position: relative;\n  background-color: var(--addition-70);\n  border: 1px solid var(--base-20);\n  border-radius: 32px;\n  width: 100%;\n  max-width: 432px;\n  height: 100%;\n  max-height: 528px;\n}\n\n.title {\n  text-align: center;\n  font: var(--font-title-6);\n  color: var(--base-110);\n  margin-top: 24px;\n}\n\n.subtitle {\n  text-align: center;\n  font: var(--font-body-4);\n  color: var(--base-80);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.description {\n  text-align: center;\n  font: var(--font-subtitle-4);\n  color: var(--base-70);\n  letter-spacing: var(-font-spacing-subtitle-4);\n}\n\n.listen-only {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  font: var(--font-subtitle-3);\n}\n\n.mic-icon {\n  fill: var(--base-70);\n}\n\n.start-call {\n  padding: 24px 0;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WebinarInvitation__container-fe7512`,
	"title": `WebinarInvitation__title-c07224`,
	"subtitle": `WebinarInvitation__subtitle-d101d0`,
	"description": `WebinarInvitation__description-c3c33c`,
	"listen-only": `WebinarInvitation__listen-only-b82e5e`,
	"listenOnly": `WebinarInvitation__listen-only-b82e5e`,
	"mic-icon": `WebinarInvitation__mic-icon-aadedb`,
	"micIcon": `WebinarInvitation__mic-icon-aadedb`,
	"start-call": `WebinarInvitation__start-call-b8994b`,
	"startCall": `WebinarInvitation__start-call-b8994b`
};
module.exports = ___CSS_LOADER_EXPORT___;
